export interface FAQItem {
  id: string;
  question: string;
  answer: string;
  category: 'chimney' | 'airduct' | 'dryervent' | 'general';
}

export const faqs: FAQItem[] = [
  {
    id: '1',
    question: 'Who does chimney cleaning near me in Jacksonville?',
    answer: 'BBM Services provides certified chimney cleaning throughout Jacksonville and surrounding areas including Ponte Vedra Beach, Orange Park, and the Beaches. Our experienced technicians are available Monday through Saturday for inspections, cleanings, and full chimney sweeps at competitive rates.',
    category: 'chimney',
  },
  {
    id: '2',
    question: 'How often should I have my chimney cleaned?',
    answer: 'The National Fire Protection Association recommends annual chimney inspections and cleanings for any chimney that is used regularly. If you burn wood frequently, you may need cleaning more often. Even if you rarely use your fireplace, an annual inspection ensures no blockages, nests, or structural damage have occurred.',
    category: 'chimney',
  },
  {
    id: '3',
    question: 'What are the signs a chimney needs cleaning?',
    answer: 'Key signs your chimney needs cleaning include a strong smoky odor when the fireplace is not in use, visible black buildup inside the firebox, smoke entering your home during a fire, a damper that is difficult to open, reduced draft efficiency, or if it has been more than a year since your last cleaning or inspection.',
    category: 'chimney',
  },
  {
    id: '4',
    question: 'How often should air ducts be cleaned?',
    answer: 'The EPA recommends air duct cleaning every 3 to 5 years for most homes. However, if anyone in your household has allergies or asthma, if you have pets, if you have recently completed a renovation, or if you notice visible dust or mold around your vents, more frequent cleaning is advisable.',
    category: 'airduct',
  },
  {
    id: '5',
    question: 'What does air duct cleaning help with?',
    answer: 'Professional air duct cleaning removes accumulated dust, pet dander, mold spores, allergens, and other contaminants from your HVAC system. This improves your indoor air quality, reduces allergy and asthma symptoms, helps your HVAC system run more efficiently, lowers energy bills, and can eliminate stale or musty odors throughout your home.',
    category: 'airduct',
  },
  {
    id: '6',
    question: 'How much does air duct cleaning cost in Jacksonville?',
    answer: 'Air duct cleaning in Jacksonville typically starts at $249 for a standard residential system with BBM Services. Final pricing depends on the size of your home, the number of vents and returns, and whether additional treatments like sanitization are needed. We offer transparent, upfront pricing with no hidden fees.',
    category: 'airduct',
  },
  {
    id: '7',
    question: 'Why is dryer vent cleaning important?',
    answer: 'Clogged dryer vents are one of the leading causes of residential fires in the United States, with nearly 2,900 dryer fires occurring annually. Lint buildup restricts airflow, causing your dryer to overheat. Regular dryer vent cleaning reduces fire risk dramatically, cuts drying time, lowers energy use, and extends the life of your appliance.',
    category: 'dryervent',
  },
  {
    id: '8',
    question: 'How much does dryer vent cleaning cost?',
    answer: 'Dryer vent cleaning with BBM Services in Jacksonville starts at just $99 for a standard residential vent line. It is one of the most affordable home safety services available and typically takes under 90 minutes. We recommend annual cleanings to maintain safety and appliance performance.',
    category: 'dryervent',
  },
  {
    id: '9',
    question: 'How long does dryer vent cleaning take?',
    answer: 'Most dryer vent cleanings take between 45 and 90 minutes depending on the length and configuration of your vent line. Our technician will inspect the full vent path, clear all lint and blockages, clean the exterior cap, and perform a performance test — all within a single visit.',
    category: 'dryervent',
  },
  {
    id: '10',
    question: 'Is BBM Services certified and insured in Jacksonville?',
    answer: 'Yes. BBM Services is fully certified, licensed, and insured to provide chimney cleaning, air duct cleaning, and dryer vent cleaning throughout Jacksonville, Florida. Our technicians receive ongoing training in safety standards, inspection procedures, and best practices to ensure you receive professional, reliable service every time.',
    category: 'general',
  },
  {
    id: '11',
    question: 'How do I book a service with BBM Services?',
    answer: 'Booking a service with BBM Services is easy. You can call us directly, submit a booking request through our website form, or use our online scheduling tool. We offer flexible weekday and Saturday appointments throughout Jacksonville and surrounding communities. Same-week availability is often available.',
    category: 'general',
  },
  {
    id: '12',
    question: 'What areas does BBM Services serve near Jacksonville?',
    answer: 'BBM Services serves the greater Jacksonville area including Jacksonville Beach, Neptune Beach, Atlantic Beach, Ponte Vedra Beach, Orange Park, Fleming Island, Mandarin, San Marco, Riverside, Baymeadows, Nocatee, and many other communities throughout Duval, St. Johns, Clay, Nassau, and surrounding counties.',
    category: 'general',
  },
];
